import React, { useRef } from 'react';
import { motion } from 'framer-motion';

export default function RippleButton({ className = '', children, onClick, ...rest }) {
  const containerRef = useRef(null);

  function createRipple(e) {
    const el = containerRef.current;
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    const ripple = document.createElement('span');
    ripple.className = 'ripple';
    ripple.style.width = `${size}px`;
    ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    el.appendChild(ripple);

    window.setTimeout(() => {
      ripple.remove();
    }, 550);
  }

  return (
    <motion.button
      ref={containerRef}
      className={`ripple-button ${className}`}
      onPointerDown={(e) => createRipple(e)}
      onClick={onClick}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 400, damping: 26 }}
      {...rest}
    >
      {children}
    </motion.button>
  );
}

